/* eslint-disable no-unused-vars */
import { createAction, createSlice } from '@reduxjs/toolkit'
//import _, { forEach } from 'lodash';
//import _ from 'lodash';

export type TConsumptionSecondColumn = {
	icon: string
	name: string
	state: number
	deviceType: string
}
type TConsumption = {
	header: Array<string>
	rows: Array<Array<any>>
}
const initialState: TConsumption = {
	header: [],
	rows: [],
}
export const consumptionSetHeader = createAction<Array<string>>(
	'consumptionSetHeader'
)
export const consumptionIns =
	createAction<Array<Array<string | number | TConsumptionSecondColumn>>>(
		'consumptionIns'
	)
export const consumptionUpd =
	createAction<Array<Array<string | number | TConsumptionSecondColumn>>>(
		'consumptionUpd'
	)
export const consumptionDel = createAction<Array<number>>('consumptionDel')

export const consumptionInsBatch = createAction<
	Array<Array<Array<string | TConsumptionSecondColumn>>>
>('consumptionIns-batch')
export const consumptionUpdBatch = createAction<
	Array<Array<Array<string | TConsumptionSecondColumn>>>
>('consumptionUpd-batch')
export const consumptionDelBatch = createAction<Array<Array<number>>>(
	'consumptionDel-batch'
)

export const consumptionClear = createAction('consumptionClear')

const consumptionSlice = createSlice({
	name: 'license',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder
			.addCase(consumptionSetHeader, (state, { payload }) => {
				state.header = payload
			})
			.addCase(consumptionClear, state => {
				state.rows = []
			})
			.addCase(consumptionIns, (state, { payload }) => {
				console.log(payload)
				state.rows = state.rows.concat(payload)
			})
			.addCase(consumptionDel, (state, { payload }) => {
				state.rows = state.rows.filter(item =>
					payload.includes(Number(item[0]))
				)
			})
			.addCase(consumptionUpd, (state, { payload }) => {
				const existingMap = new Map(state.rows.map(row => [row[0], row]))

				payload.forEach(inRow => {
					const id = inRow[0]
					if (existingMap.has(id)) {
						existingMap.set(id, inRow)
					}
				})

				state.rows = Array.from(existingMap.values())

				/** Строки для обновления данных в таблице (по соответствию поля Идентификатор) */
				/**
				 * На каждое уведомление
				 */
			})
			.addCase(consumptionInsBatch, (state, { payload }) => {
				payload.forEach(batch => {
					state.rows = state.rows.concat(batch)
				})
			})

			// Добавляем обработку пакетного обновления
			.addCase(consumptionUpdBatch, (state, { payload }) => {
				const existingMap = new Map(state.rows.map(row => [row[0], row]))

				payload.forEach(batch => {
					batch.forEach(inRow => {
						const id = inRow[0]
						if (existingMap.has(id)) {
							existingMap.set(id, inRow)
						}
					})
				})

				state.rows = Array.from(existingMap.values())
			})

			// Добавляем обработку пакетного удаления
			.addCase(consumptionDelBatch, (state, { payload }) => {
				payload.forEach(batch => {
					state.rows = state.rows.filter(
						item => !batch.includes(Number(item[0]))
					)
				})
			})
	},
})

export default consumptionSlice.reducer
